import {
  aromaInput,
  AromaInputVariantProps,
} from "@zenchef/styled-system/recipes";
import { ElementRef, forwardRef } from "react";
import { Field, type FieldInputProps } from "@ark-ui/react";
import Icon from "../Icon/Icon";
import { IconName } from "@zenchef/icomoon";
import { Text } from "../typography/Text";
import { cx } from "@zenchef/styled-system/css";
import { FieldProps } from "../../utils/types";
import DatePicker from "./DatePicker";
import PasswordInput from "./PasswordInput";
export type { Props as DatePickerProps } from "./DatePicker";

export interface InputProps
  extends AromaInputVariantProps,
    Omit<FieldInputProps, "size">,
    FieldProps {
  iconName?: IconName;
  icon?: JSX.Element;
  iconRight?: boolean;
  iconLeftName?: IconName;
  suffix?: string;
}

const Input = forwardRef<ElementRef<"div">, InputProps>(
  (
    {
      className,
      testId,
      iconName,
      icon,
      iconRight,
      iconLeftName,
      prefix,
      suffix,
      ...propsWithVariants
    },
    ref,
  ) => {
    const [variants, props] = aromaInput.splitVariantProps(propsWithVariants);
    const classes = aromaInput(variants);
    const { required, disabled } = props;

    const testIds = testId
      ? {
          root: testId,
          input: `${testId}-input`,
        }
      : {};

    return (
      <Field.Root
        ref={ref}
        className={cx(classes.container, className)}
        disabled={variants.status === "readOnly" || disabled}
        data-testid={testIds.root}
      >
        {prefix ? <Text textStyle="title.xs">{prefix}</Text> : null}
        {iconLeftName ? <Icon name={iconLeftName} /> : null}
        {iconName && !iconRight ? <Icon name={iconName} /> : null}
        {icon && !iconName && !iconRight ? icon : null}
        <Field.Input
          className={classes.input}
          data-testid={testIds.input}
          {...props}
        />
        {iconName && iconRight ? <Icon name={iconName} /> : null}
        {icon && !iconName && iconRight ? icon : null}
        {suffix ? <Text textStyle="title.xs">{suffix}</Text> : null}
        {required ? <Icon name="asterisk" aria-required="true" /> : null}
      </Field.Root>
    );
  },
);

export default Object.assign(Input, { DatePicker, PasswordInput });
